<template>
  <vetster-search-facet-group
    :label="$t('search.areas-of-interest')"
    group="AREAS_OF_INTEREST"
    :expanded="expanded"
  >
    <div class="relative">
      <div
        v-if="disabled"
        class="
          absolute
          inset-0
          bg-white
          opacity-75
          text-indigo-600
          font-medium
          text-base
          flex
          items-center
          justify-center
        "
      />
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 xl:grid-cols-2 gap-1">
        <div
          v-for="option in getAreasOfInterestOptions"
          :key="`${option.value}`"
          class="flex items-center"
        >
          <div class="flex items-center h-5">
            <label
              :for="option.value"
              :class="
                disabled
                  ? 'cursor-not-allowed text-neutral-400'
                  : 'cursor-pointer text-neutral-700'
              "
            >
              <input
                :id="option.value"
                v-model="input"
                :disabled="disabled"
                type="checkbox"
                class="
                  cursor-pointer
                  focus:ring-indigo-500
                  h-4
                  w-4
                  text-indigo-600
                  border-neutral-300
                  rounded
                "
                :value="option.value"
              />
              <span class="text-sm ml-1.5">{{ option.text }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </vetster-search-facet-group>
</template>

<script>
import VetsterSearchFacetGroup from '@/components/VetsterSearchFacetGroup';
import useSearchData from '@/composables/use-search-data';

export default {
  name: 'VetsterAreasOfInterestInput',

  components: { VetsterSearchFacetGroup },

  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    expanded: {
      default: false,
      type: Boolean,
    },
  },

  setup() {
    const { getAreasOfInterestOptions } = useSearchData();

    return { getAreasOfInterestOptions };
  },

  data() {
    return {
      input: [],
    };
  },

  computed: {
    areasOfInterest() {
      return this.$store.state.search.inputs.areas_of_interest || [];
    },
  },

  watch: {
    input: {
      handler(data) {
        this.$store.commit('search/setInputs', { areas_of_interest: data });
      },
      deep: true,
    },
    areasOfInterest: {
      handler(data) {
        this.input = data;
      },
      deep: true,
    },
  },

  created() {
    this.input = this.areasOfInterest;
  },
};
</script>
